import * as React from 'react';
import * as toastr from 'toastr';

import StaffDetailsForm from './StaffDetailsForm';
import Button from '../../components/buttons/Button';
import { Validation, InputError } from '../../common/utils';

interface Props {
	className?: string;
	user: UserDetails;
	actions: any;
	history?: any;
	match?: any;
	saveRedirect?: string;
}
class StaffDetailsPage extends React.Component<Props, any> {
	errors = {
		email: {} as InputError,
		mailingPostalCode: {} as InputError,
		billingPostalCode: {} as InputError
	};

	onUserChange = (e: any) => {
		const user = {
			...this.props.user,
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		};

		this.props.actions.setUser(user);
	}

	validate = () => {
		// true means invalid
		return {
			email: Validation.validateEmail(this.props.user.email),
			mailingPostalCode: Validation
				.validatePostalCode(this.props.user.mailingPostalCode, 'Mailing postal code is not valid.'),
			billingPostalCode: Validation
				.validatePostalCode(this.props.user.billingPostalCode, 'Billing postal code is not valid.')
		};
	}

	save = () => {
		const user = { ...this.props.user };
		if (user.isSameAddress) {
			user.billingAddress = user.mailingAddress;
			user.billingCity = user.mailingCity;
			user.billingProvince = user.mailingProvince;
			user.billingPostalCode = user.mailingPostalCode;
			user.billingCountry = user.mailingCountry;
		}

		this.props.actions.saveStaff(user)
			.then(() => {
				toastr.success('Saved!');
				if (this.props.saveRedirect) {
					this.props.history.push(this.props.saveRedirect);
				}
			});
	}

	isSaveDisabled = () => {
		if (this.errors.email.hasError ||
			this.errors.mailingPostalCode.hasError ||
			(!this.props.user.isSameAddress && this.errors.billingPostalCode.hasError)
		) {
			return true;
		}

		return false;
	}

	render() {
		this.errors = this.validate();
		return (
			<div className={this.props.className}>
				<StaffDetailsForm user={this.props.user} onUserChange={this.onUserChange} errors={this.errors} />
				<Button onClick={this.save} disabled={this.isSaveDisabled()} className="btn-primary mt-4">Save</Button>
			</div>
		);
	}
}
export default StaffDetailsPage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/staff/StaffDetailsPage.tsx